import { Capacitor } from "@capacitor/core";
import { useMemo } from "react";
import { useMediaQuery, useTheme } from "@mui/material";

const isMobileWebViewport = () => {
    if (typeof window === 'undefined' || typeof window.matchMedia !== 'function') {
        return false;
    }

    return window.matchMedia('(max-width: 899.95px)').matches;
};

export const getPlatformView = () => {
    const isNativePlatform = Capacitor.isNativePlatform();
    const isMobileWeb = !isNativePlatform && isMobileWebViewport();
    const isAppView = isNativePlatform || isMobileWeb;

    return {
        isAppView,
        isDesktopWeb: !isAppView,
        isMobileWeb,
        isNativePlatform
    };
};

const useAppView = () => {
    const theme = useTheme();
    const isNativePlatform = Capacitor.isNativePlatform();
    const isMobileWeb = useMediaQuery(theme.breakpoints.down('md'));

    return useMemo(() => {
        const appView = isNativePlatform || isMobileWeb;

        return {
            isAppView: appView,
            isDesktopWeb: !appView,
            isMobileWeb: !isNativePlatform && isMobileWeb,
            isNativePlatform
        };
    }, [isMobileWeb, isNativePlatform]);
};

export default useAppView;
